import { JBTheme } from '@bjb-gcrm/gcrm-frontend-components';
import { jbColors } from '../jbColors';
import { alpha } from '@mui/material';

export const MuiTableCell = {
  styleOverrides: {
    root: {
      ...JBTheme.typography.body2,
      fontWeight: 300,
      borderBottom: `1px solid ${alpha(jbColors.app.lightGrey, 0.5)}`,
    },
    head: {
      ...JBTheme.typography.body2,
      fontWeight: 300,
      padding: '8px 16px',
      borderBottomColor: jbColors.core.reflexBlue[40],
      color: jbColors.core.reflexBlue[100],
    },
    sizeSmall: {
      padding: '8px 24px 8px 8px',
    },
  },
};
